import { Dto } from '@core/data/dto/dto';
import { DtoExport, DtoForceConstructor, DtoImport } from '@core/utils/dto';
import { EmployeeProviderDataSchema } from './employee-provider-data.schema';
import { Moment } from 'moment';
import { EmployeeProviderMetadata } from './employee-provider-metadata';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { DtoType } from '@core/data/dto/dto-types';

@DtoForceConstructor
export class EmployeeProviderData {

    public id: string;
    public active: boolean;
    public company: string;
    public defaultNetPaySplit: string;
    public dob: Moment;
    public email: string;
    public firstName: string;
    public lastName: string;
    public metadata: EmployeeProviderMetadata;
    public paymentMethodPreference: string;
    public primaryWorkplace: string;
    public ssnLastFour: string;
    public ssnValidationStatus: string;
    public startDate: Moment;
    public w2ElectronicConsentProvided: boolean;
    public workplaces: string[];

    @DtoImport(EmployeeProviderDataSchema)
    static import(dto: Dto): any {
        return new EmployeeProviderData(dto);
    }

    constructor(value?: any) {
        if (value) {
            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: EmployeeProviderDataSchema,
        },
    ])
    export(type?: DtoType): any {}
}
